module.exports = __webpack_public_path__ + "static/media/editPen24.21b600aa.svg";